import { useOffline } from '@/contexts/OfflineContext';
import { Cloud, CloudOff, RefreshCw } from 'lucide-react';

/**
 * Small sync indicator badge for the bottom nav or status areas.
 * Shows pending count when offline or syncing.
 */
export default function SyncStatus() {
  const { isOnline, pendingCount, isSyncing, triggerSync, failedCount, unownedCount, storageError } = useOffline();

  if (storageError || unownedCount > 0) return <span role="status" className="text-xs text-amber-700">Saved entries need review</span>;
  if (isSyncing) {
    return (
      <button
        className="relative flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-xs font-semibold"
        disabled
      >
        <RefreshCw size={12} className="animate-spin" />
        Syncing...
      </button>
    );
  }

  if (!isOnline) {
    return (
      <div className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 text-xs font-semibold">
        <CloudOff size={12} />
        Offline
        {pendingCount > 0 && (
          <span className="ml-1 bg-amber-500 text-white w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold">
            {pendingCount}
          </span>
        )}
      </div>
    );
  }

  if (pendingCount > 0) {
    return (
      <button
        onClick={() => triggerSync()}
        className="min-h-11 flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-xs font-semibold"
      >
        <RefreshCw size={12} />
        {failedCount ? 'Retry' : 'Sync'} {pendingCount}
      </button>
    );
  }

  // All synced, online
  return (
    <div className="flex items-center gap-1 px-2 py-1 text-xs text-muted-foreground">
      <Cloud size={12} className="text-forest-500" aria-label="No pending uploads" />
    </div>
  );
}
